export default class BundleProduct extends HTMLElement {
  #product = {};

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleBundleUpdate = this.handleBundleUpdate.bind(this);
  }

  initEventListeners() {
    this.querySelectorAll('[data-action]').forEach((el) => {
      el.addEventListener('click', this.handleClick);
    });
    document.addEventListener('bundleUpdated', this.handleBundleUpdate);
  }

  handleBundleUpdate(event) {
    const { products } = event.detail;
    this.classList.remove('disabled');

    if (products.some((product) => product?.id === this.#product.id)) {
      this.classList.add('added');
    } else {
      this.classList.remove('added');
      if (event.detail.isFull) {
        this.classList.add('disabled');
      }
    }
  }

  handleClick(event) {
    const selectedVariantElement = this.querySelector(
      '[data-selected-variant]',
    );

    const variantId = selectedVariantElement
      ? Number(selectedVariantElement.getAttribute('data-selected-variant'))
      : null;

    if (variantId) {
      const variant = this.#product.variants.find((v) => v.id === variantId);

      if (variant) {
        this.#product = {
          ...this.#product,
          variants: [
            variant,
            ...this.#product.variants.filter((v) => v.id !== variantId),
          ],
        };
      }
    }

    document.dispatchEvent(
      new CustomEvent(`${event.currentTarget.dataset.action}BundleProduct`, {
        detail: this.#product,
      }),
    );
  }

  connectedCallback() {
    this.#product = JSON.parse(
      this.querySelector('[data-bundle-product]')?.textContent || '{}',
    );
    this.initEventListeners();
  }

  disconnectedCallback() {
    this.querySelectorAll('[data-action]').forEach((el) => {
      el.removeEventListener('click', this.handleClick);
    });
    document.removeEventListener('bundleUpdated', this.handleBundleUpdate);
  }
}
